import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { theme } from "@huub-web/ui/theme/css/theme.css";

export const mapContainer = style({
  position: "relative",
  width: "100%",
  height: "60dvh",
  minHeight: rem(400),
  maxHeight: rem(600),
  backgroundColor: theme.colors.backgroundShade,
  borderRadius: theme.borderRadiuses.m,
  overflow: "hidden",
});

export const amenitiesGridStyle = style({
  gap: theme.spacings.m,
});
